import {
  WaitingActions,
  WiseOwlIngress,
} from "@twiliointernal/e2-commons-shared-definitions";

export type ChatActivityData = {
  taskQueueSid: string;
  taskQueueEstWaitTime: number;
  taskQueuePosition: number;
  accountSid: string;
  taskSid: string;
  taskQueueFriendlyName: string;
  userSid: string;
  assignmentStatus: string;
};
export enum TransferType {
  Queue = "queue",
  Agent = "agent",
}

export interface TransferToQueueProps {
  type: TransferType.Queue;
  queue: string;
}

export interface WaitingInLineProps {
  liveChatId: string;
  token: string;
  chatActivitySyncMapId: string;
  // Contains metadata for transfers to queue, for rendering TTQ related copy
  transfer: TransferToQueueProps;
  ingress?: WiseOwlIngress;
  actions?: WaitingActions;
}
